/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'

import { isTruthy } from '@local/utils'

import ProfileDoneModal from '@web/components/Modal/ProfileDone/v2'
import { useModal } from '@web/components/Modal/useModal'
import useMe from '@web/hooks/useMe'
import { useLocalStorage } from 'react-use'

export function useProfileDoneModal() {
  const { me } = useMe()
  const { openModal } = useModal(ProfileDoneModal)
  const PROFILE_WELCOME_KEY = `myplace-profile-welcome-${me?.id}`
  const [profileKey, _, removeProfileKey] = useLocalStorage(PROFILE_WELCOME_KEY)

  useEffect(() => {
    if (!me) return

    if (isTruthy(profileKey)) {
      openModal({
        nickname: me.profile.nickname,
        hasReview: me.stat.reviewCount > 0,
        profileImageUrl: me.profile.originImageUrl ?? undefined,
      })
      removeProfileKey()
    }
  }, [profileKey])
}
